import { buildOption } from '@/core/components/BoxSelector';
import { FeatureId } from '@/core/feature-flags/enums';

export default class OAuthProviderSelectorController {
  constructor() {
    this.options = [
      buildOption('microsoft', 'fab fa-microsoft', 'Microsoft', 'Поставщик OAuth Microsoft', 'microsoft', FeatureId.HIDE_INTERNAL_AUTH),
      buildOption('google', 'fab fa-google', 'Google', 'Поставщик OAuth Google', 'google', FeatureId.HIDE_INTERNAL_AUTH),
      buildOption('github', 'fab fa-github', 'Github', 'Поставщик OAuth GitHub', 'github', FeatureId.HIDE_INTERNAL_AUTH),
      buildOption('custom', 'fa fa-user-check', 'Custom', 'Другой поставщик OAuth', 'custom'),
    ];
  }
}
